var React = require('react');

function Options (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#2F2F2F","fillRule":"evenodd"},[React.createElement("circle",{"cx":"2","cy":"2","r":"2","key":0}),React.createElement("circle",{"cx":"2","cy":"8","r":"2","key":1}),React.createElement("circle",{"cx":"2","cy":"14","r":"2","key":2})]));
}

Options.defaultProps = {"width":"4","height":"16"};

module.exports = Options;

Options.default = Options;
